/* eslint-disable @typescript-eslint/dot-notation */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-signincallback',
    templateUrl: './signincallback.component.html',
    styleUrls: ['./signincallback.component.css'],
    standalone: true
})
export class SignInCallbackComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private authService: AuthService,
    private router: Router) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.authService.whoisSignedIn().subscribe(
        data => {
          if ((data)&&(data.id)) {
            localStorage.setItem('username', data.username);
            localStorage.setItem('userid', data.id);
            localStorage.setItem('expires', data.expires);
            environment.aiNameSex = data.ai_name_sex === true;
            // logowanie przez Facebooka nie emituje authStateChanged(true) - flaga
            // komunikatu o wygaslej sesji musi sie wyzerowac i tu
            this.authService.sessionExpiredShown = false;

            // Cel powrotu MUSI byc sciezka wewnatrz aplikacji. Wczesniej szedl
            // tu surowy parametr `ref` prosto do window.location.href, wiec
            // ?ref=https://obcy.example dawal przekierowanie na cudza strone
            // z naszej domeny (phishing), a ?ref=javascript:... wykonanie kodu
            // w naszym originie - czyli kradziez ciasteczka sesji.
            // router.navigateByUrl z definicji nie wychodzi poza aplikacje.
            const zapamietany = this.authService.getRedirectUrl();
            this.authService.clearRedirectUrl();
            const ref = params['ref'];
            const cel = zapamietany
              ?? (this.authService.isSafeReturnUrl(ref) ? ref as string : '/');
            void this.router.navigateByUrl(cel);
          }
      });
    });
  }

}
